import { render, staticRenderFns } from "./ObjectCardTags.vue?vue&type=template&id=2dd1a63f&scoped=true&"
import script from "./ObjectCardTags.vue?vue&type=script&lang=js&"
export * from "./ObjectCardTags.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCardTags.vue?vue&type=style&index=0&id=2dd1a63f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1a63f",
  null
  
)

export default component.exports